module.exports = __webpack_public_path__ + "static/media/home.94c039e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home.png
// module id = 30
// module chunks = 0